var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "tabContent", attrs: { id: "links1" } }, [
    _c(
      "div",
      { staticClass: "oldInnerWrapper" },
      [
        _c("div", { staticClass: "bold500" }, [_vm._v("Web-Links erfassen")]),
        _vm._v(" "),
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticStyle: { "margin-top": "20px" } }, [
          _vm._v(
            "Hinweis: Wenn du deinen Beitrag bereits als Embed-Code erfasst hast, musst du ihn nicht mehr als Web-Link einreichen."
          )
        ]),
        _vm._v(" "),
        _vm._l(_vm.externModels, function(model, index) {
          return _c("form", { key: model }, [
            index > 0
              ? _c("div", { staticClass: "clearfix" }, [
                  _c("hr"),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "btn btn-white",
                      staticStyle: { float: "right" },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          _vm.externModels.splice(index, 1)
                        }
                      }
                    },
                    [_c("i", { staticClass: "fa fa-close" })]
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _c(
              "select",
              {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: model.elements[1].text,
                    expression: "model.elements[1].text"
                  },
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: {
                      rules: {
                        required: _vm.isExternPlatformRequired(model, index)
                      }
                    },
                    expression:
                      "{rules: {'required': isExternPlatformRequired(model, index)}}"
                  }
                ],
                class: { error: _vm.errors.has("platform_ext_" + index) },
                staticStyle: { "margin-top": "20px" },
                attrs: { name: "platform_ext_" + index },
                on: {
                  change: function($event) {
                    var $$selectedVal = Array.prototype.filter
                      .call($event.target.options, function(o) {
                        return o.selected
                      })
                      .map(function(o) {
                        var val = "_value" in o ? o._value : o.value
                        return val
                      })
                    model.elements[1].text = $event.target.multiple
                      ? $$selectedVal
                      : $$selectedVal[0]
                  }
                }
              },
              [
                _c("option", { attrs: { value: "" } }, [
                  _vm._v("Plattform auswählen")
                ]),
                _vm._v(" "),
                _c("option", { attrs: { value: "INSTAGRAM" } }, [
                  _vm._v("Instagram")
                ]),
                _vm._v(" "),
                _c("option", { attrs: { value: "FACEBOOK" } }, [
                  _vm._v("Facebook")
                ]),
                _vm._v(" "),
                _c("option", { attrs: { value: "PINTEREST" } }, [
                  _vm._v("Pinterest")
                ]),
                _vm._v(" "),
                _c("option", { attrs: { value: "TIKTOK" } }, [
                  _vm._v("TikTok")
                ]),
                _vm._v(" "),
                _c("option", { attrs: { value: "YOUTUBE" } }, [
                  _vm._v("Youtube")
                ]),
                _vm._v(" "),
                _c("option", { attrs: { value: "OWNBLOG" } }, [
                  _vm._v("Eigener Blog")
                ]),
                _vm._v(" "),
                _c("option", { attrs: { value: "SHOPS" } }, [
                  _vm._v("Bewertungsplattformen & Shops")
                ]),
                _vm._v(" "),
                _c("option", { attrs: { value: "OTHER" } }, [
                  _vm._v("Sonstiges")
                ])
              ]
            ),
            _vm._v(" "),
            _c("label", { staticStyle: { "margin-top": "20px" } }, [
              _vm._v("Link")
            ]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: model.elements[2].text,
                  expression: "model.elements[2].text"
                },
                {
                  name: "validate",
                  rawName: "v-validate",
                  value: {
                    rules: {
                      required: _vm.isExternLinkRequired(model, index),
                      url: [true]
                    }
                  },
                  expression:
                    "{rules: {'required': isExternLinkRequired(model, index), 'url': [true]}}"
                }
              ],
              class: { error: _vm.errors.has("link_ext_" + index) },
              attrs: {
                name: "link_ext_" + index,
                type: "text",
                placeholder: "URL zu deinem Post"
              },
              domProps: { value: model.elements[2].text },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  model.elements[2].text = $event.target.value
                }
              }
            }),
            _vm._v(" "),
            _vm.errors.has("link_ext_" + index + ":url")
              ? _c("p", { staticClass: "errorText" }, [
                  _c("strong", [
                    _vm._v(
                      "Das ist kein gültiger Web-Link. Gültige Web-Links müssen z.B. alle mit http:// oder https:// beginnen"
                    )
                  ])
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("label", { staticStyle: { "margin-top": "20px" } }, [
              _vm._v("Titel")
            ]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: model.elements[3].text,
                  expression: "model.elements[3].text"
                },
                {
                  name: "validate",
                  rawName: "v-validate",
                  value: {
                    rules: { required: _vm.isExternTitleRequired(model, index) }
                  },
                  expression:
                    "{rules: {'required': isExternTitleRequired(model, index)}}"
                }
              ],
              class: { error: _vm.errors.has("title_ext_" + index) },
              attrs: {
                name: "title_ext_" + index,
                type: "text",
                placeholder: "Max. 90 Zeichen",
                maxlength: "90"
              },
              domProps: { value: model.elements[3].text },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  model.elements[3].text = $event.target.value
                }
              }
            }),
            _vm._v(" "),
            _c("label", { staticStyle: { "margin-top": "20px" } }, [
              _vm._v("Kurz-Beschreibung")
            ]),
            _vm._v(" "),
            _c("textarea", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: model.elements[4].text,
                  expression: "model.elements[4].text"
                },
                {
                  name: "validate",
                  rawName: "v-validate",
                  value: {
                    rules: {
                      required: _vm.isExternDescriptionRequired(model, index)
                    }
                  },
                  expression:
                    "{rules: {'required': isExternDescriptionRequired(model, index)}}"
                }
              ],
              class: { error: _vm.errors.has("description_ext_" + index) },
              attrs: {
                name: "description_ext_" + index,
                placeholder: "Max. 145 Zeichen",
                maxlength: "145"
              },
              domProps: { value: model.elements[4].text },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  model.elements[4].text = $event.target.value
                }
              }
            })
          ])
        }),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "btn btn-white teaserButton width100",
            staticStyle: { "margin-top": "20px" },
            attrs: { type: "button" },
            on: { click: _vm.addExternLink }
          },
          [_vm._v("Weiteren Link hinzufügen")]
        ),
        _vm._v(" "),
        _c("hr"),
        _vm._v(" "),
        _c("form", [
          _c(
            "div",
            { staticClass: "textAlignRight buttonBlockContainerRight" },
            [
              _c(
                "button",
                {
                  staticClass: "btn btn-white teaserButton width50",
                  attrs: { type: "button" },
                  on: { click: _vm.cancel }
                },
                [_vm._v("Abbrechen")]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn btn-white teaserButton width50",
                  attrs: { type: "button", disabled: _vm.errors.any() },
                  on: { click: _vm.save }
                },
                [_vm._v("Speichern")]
              )
            ]
          )
        ])
      ],
      2
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        ref: "modalDialog",
        staticClass: "modal fade",
        attrs: { tabindex: "-1", role: "dialog" }
      },
      [_vm._m(1)]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c(
        "a",
        {
          attrs: {
            target: "_blank",
            href: "/project/sogehts/pinboard/sofunktionierts/show.html"
          }
        },
        [_vm._v("Was ist damit gemeint?")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "modal-dialog old-modal-dialog",
        attrs: { role: "document" }
      },
      [
        _c("div", { staticClass: "modal-content" }, [
          _c("div", { staticClass: "modal-header" }, [
            _c("h5", { staticClass: "modal-title" }, [
              _vm._v("Speichern fehlgeschlagen")
            ]),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "close",
                attrs: {
                  type: "button",
                  "data-dismiss": "modal",
                  "aria-label": "Close"
                }
              },
              [_c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("×")])]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "modal-body" }, [
            _vm._v(
              "\n                Deine Eingabe war leider nicht gültig und kann nicht gespeichert werden.\n            "
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "modal-footer" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-secondary",
                attrs: { type: "button", "data-dismiss": "modal" }
              },
              [_vm._v("OK")]
            )
          ])
        ])
      ]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-4ecbc6a0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ecbc6a0","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/UserContentLinks.vue
// module id = 462
// module chunks = 2